<template>
	<v-card class="nav-panel" rounded="xl">
		<div class="nav-panel__header">
			<v-icon color="primary">notifications</v-icon>
			<span class="nav-panel__title">{{ t('Notifications') }}</span>
			<v-btn icon variant="text" size="small" :title="t('Synchronize')" :aria-label="t('Synchronize')" @click="reloadNotifications">
				<v-icon>sync</v-icon>
			</v-btn>
			<v-btn icon variant="text" size="small" :disabled="!items.length" :title="t('Mark all notifications as read')" :aria-label="t('Mark all notifications as read')" @click="act(clearNotifications)">
				<v-icon>delete_sweep</v-icon>
			</v-btn>
		</div>
		<v-divider />

		<v-list v-if="items.length" class="nav-panel__list">
			<v-list-item v-for="item in items" :key="item.id" :link="item.application === 'DCRFO'" class="nav-panel__item" @click="open(item)">
				<template #prepend>
					<v-avatar color="primary" variant="tonal" size="36">
						<v-icon size="20">{{ item.icon }}</v-icon>
					</v-avatar>
				</template>
				<v-list-item-title class="nav-panel__item-title">{{ item.title }}</v-list-item-title>
				<div class="nav-panel__item-text">{{ item.message }}</div>
				<div class="nav-panel__item-meta">{{ item.date }}</div>
				<template #append>
					<v-btn icon variant="text" size="small" @click.stop="readNotification(item.id)">
						<v-icon>delete</v-icon>
					</v-btn>
				</template>
			</v-list-item>
		</v-list>

		<div v-else class="nav-panel__empty">
			<v-icon size="40">empty_dashboard</v-icon>
			<p>{{ t('NoNotifications') }}</p>
		</div>
	</v-card>
</template>

<script setup>
import { computed } from 'vue';
import { legacyNav } from '@/iframe/legacyNavState';
import { clearNotifications, openNotification, readNotification, reloadNotifications } from '@/iframe/legacyNavActions';
import { useTranslator } from '@/composables/useTranslator';

const emit = defineEmits(['close']);
const t = useTranslator();

const items = computed(() => legacyNav.notifications);

const act = (action) => {
	emit('close');
	action();
};

const open = (item) => {
	if (item.application === 'DCRFO') act(() => openNotification(item.id));
};
</script>
